import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=438a503c&scoped=true&"
import script from "./AddTemplate.vue?vue&type=script&lang=js&"
export * from "./AddTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=438a503c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a503c",
  null
  
)

component.options.__file = "AddTemplate.vue"
export default component.exports